import _ from 'lodash-es';

/**
 * 多时间纬度, 多指标纬度, 单值
 *
 * 输出格式:
 *
 * {
 *  "DAY": {
 *     "ACTIVE_MEMBER": {
 *        "RATE": 0.1
 *        "VALUE": 1000
 *      }
 *      ...
 *   }
 *   ...
 * }
 * @param {*} data Report 响应集合
 */
const mulTimeDimensionMulIndexSinValue = (data) =>
  Object.entries(_.groupBy(data, 'timeDimension')).reduce(
    (timeAcc, timeCur) =>
      Object.assign(timeAcc, {
        // 时间纬度
        [timeCur[0]]: timeCur[1].reduce(
          (indexAcc, indexCur) =>
            Object.assign(indexAcc, {
              // 指标纬度
              [indexCur.index]: indexCur.values.reduce(
                (valueAcc, valueCur) =>
                  Object.assign(valueAcc, {
                    // 值纬度
                    [valueCur.valueType]: valueCur.value,
                  }),
                {},
              ),
            }),
          {},
        ),
      }),
    {},
  );

/**
 * 多时间纬度, 多指标纬度, 多值
 *
 * 输出格式:
 *
 * {
 *  "DAY": {
 *     "ACTIVE_MEMBER": [{
 *        "RATE": 0.1
 *        "VALUE": 1000
 *      }]
 *      ...
 *   }
 *   ...
 * }
 * @param {*} data Report 响应集合
 */
const mulTimeDimensionMulIndexMulValue = (data) =>
  Object.entries(_.groupBy(data, 'timeDimension')).reduce(
    (timeAcc, timeCur) =>
      Object.assign(timeAcc, {
        // 时间纬度
        [timeCur[0]]: Object.entries(_.groupBy(timeCur[1], 'index')).reduce(
          (indexAcc, indexCur) =>
            Object.assign(indexAcc, {
              // 指标纬度
              [indexCur[0]]: indexCur[1].reduce(
                (valueAcc, valueCur) =>
                  valueAcc.concat([
                    valueCur.values.reduce(
                      (valAcc, valCur) =>
                        Object.assign(valAcc, {
                          // 值纬度
                          [valCur.valueType]: valCur.value,
                        }),
                      {},
                    ),
                  ]),
                [],
              ),
            }),
          {},
        ),
      }),
    {},
  );

/**
 * 多时间纬度, 单指标纬度, 多值
 *
 * 输出格式:
 *
 * {
 *  "DAY": [{
 *     "RATE": 0.1
 *     "VALUE": 1000
 *   }]
 *   ...
 * }
 * @param {*} data Report 响应集合
 */
const mulTimeDimensionSinIndexMulValue = (data) =>
  Object.entries(_.groupBy(data, 'timeDimension')).reduce(
    (timeAcc, timeCur) =>
      Object.assign(timeAcc, {
        // 时间纬度
        [timeCur[0]]: timeCur[1].reduce(
          (indexAcc, indexCur) =>
            indexAcc.concat([
              indexCur.values.reduce(
                (valueAcc, valueCur) =>
                  Object.assign(valueAcc, {
                    [valueCur.valueType]: valueCur.value,
                  }),
                {},
              ),
            ]),
          [],
        ),
      }),
    {},
  );

/**
 * 单时间纬度, 单指标纬度, 多值
 *
 * 输出格式:
 *
 *[
 *  {
 *    "RATE": 0.1
 *    "VALUE": 1000
 *  }
 *]
 * @param {*} data Report 响应集合
 */
const sinTimeDimensionSinIndexMulValue = (data) =>
  Object.values(mulTimeDimensionSinIndexMulValue(data))[0];

/**
 * 多时间纬度, 单指标纬度, 单值
 *
 * 输出格式:
 *
 * {
 *  "DAY": {
 *     "RATE": 0.1
 *     "VALUE": 1000
 *   }
 *   ...
 * }
 * @param {*} data Report 响应集合
 */
const mulTimeDimensionSinIndexSinValue = (data) =>
  Object.entries(_.groupBy(data, 'timeDimension')).reduce(
    (timeAcc, timeCur) =>
      Object.assign(timeAcc, {
        // 时间纬度
        [timeCur[0]]: timeCur[1][0].values.reduce(
          (valueAcc, valueCur) =>
            Object.assign(valueAcc, {
              [valueCur.valueType]: valueCur.value,
            }),
          {},
        ),
      }),
    {},
  );

/**
 * 单时间纬度, 多指标纬度, 多值
 *
 * 输出格式:
 *
 * {
 *  "ACTIVE_MEMBER": [{
 *     "RATE": 0.1
 *     "VALUE": 1000
 *   }]
 *   ...
 * }
 * @param {*} data Report 响应集合
 */
const sinTimeDimensionMulIndexMulValue = (data) =>
  Object.entries(_.groupBy(data, 'index')).reduce(
    (indexAcc, indexCur) =>
      Object.assign(indexAcc, {
        // 指标纬度
        [indexCur[0]]: indexCur[1].reduce(
          (valueAcc, valueCur) =>
            valueAcc.concat([
              valueCur.values.reduce(
                (valAcc, valCur) =>
                  Object.assign(valAcc, {
                    // 值纬度
                    [valCur.valueType]: valCur.value,
                  }),
                {},
              ),
            ]),
          [],
        ),
      }),
    {},
  );

const mulTimeDimensionMulIndexMulValueType = (data) =>
  Object.entries(_.groupBy(data, 'timeDimension')).reduce(
    (timeAcc, timeCur) =>
      Object.assign(timeAcc, {
        // 时间纬度
        [timeCur[0]]: Object.entries(_.groupBy(timeCur[1], 'index')).reduce(
          (indexAcc, indexCur) =>
            Object.assign(indexAcc, {
              // 指标纬度
              [indexCur[0]]: indexCur[1].reduce(
                (valueAcc, valueCur) =>
                  valueAcc.concat([
                    valueCur.values.reduce(
                      (valAcc, valCur) =>
                        Object.assign(valAcc, {
                          // 值纬度
                          [valCur.valueType]: valCur.value,
                          [indexCur[0]]: valCur.value,
                        }),
                      {},
                    ),
                  ]),
                [],
              ),
            }),
          {},
        ),
      }),
    {},
  );

export {
  mulTimeDimensionMulIndexMulValue,
  mulTimeDimensionMulIndexSinValue,
  mulTimeDimensionSinIndexMulValue,
  mulTimeDimensionSinIndexSinValue,
  sinTimeDimensionSinIndexMulValue,
  sinTimeDimensionMulIndexMulValue,
  mulTimeDimensionMulIndexMulValueType,
};
